/**
 * React SPA Base Path Configuration
 *
 * The React app is served at the root (/).
 *
 * To change the base path, update ALL of these locations:
 *   1. react-app/vite.config.ts → base
 *   2. react-app/src/routes/index.tsx → createBrowserRouter basename
 *   3. react-app/src/config/auth.config.ts → redirect_uri & post_logout_redirect_uri
 *   4. aspnet-core/src/motr.HttpApi.Host/motrHttpApiHostModule.cs → UseSpa fallback
 *   5. OpenIddictApplications DB table → RedirectUris & PostLogoutRedirectUris for motr_App
 */
export const APP_BASE_PATH = '/';
